import { useStaticQuery, graphql } from 'gatsby'

export const getSymposiumSeriesHeroData = () => {
  const { allStrapiCommonHero } = useStaticQuery(symposiumSeriesHeroDataQuery)
  let symposiumHeroData = allStrapiCommonHero.nodes[0].Heros.filter(
    value => Object.keys(value).length !== 0
  )
  return symposiumHeroData[0]
}

const symposiumSeriesHeroDataQuery = graphql`
  query {
    allStrapiCommonHero {
      nodes {
        Heros {
          ... on STRAPI__COMPONENT_SHARED_SYMPOSIUM_SERIES_HERO {
            id
            button {
              id
              name
              url
            }
            description {
              data {
                description
              }
            }
            title
          }
        }
      }
    }
  }
`
